export default "__VITE_ASSET__vx9K95ro__"